import { isDeploymentFeatureEnabled } from "@/shared/config/deployment-features"
import { SidebarSub } from '../sidebar-sub'
import { SidebarItem } from '../sidebar-item'
import { useAppSelector } from '@/shared/lib/redux'
import { selectSidebarType } from '../../model'
import { SidebarType } from '../../config'
import { selectCommunityInfo } from '@/entities/community'
import { selectLoyaltyLevelsGate, selectRestaurantMenusGate } from '@/entities/community-sections-availability'
import { useLocation } from 'react-router-dom'
import HouseSvg from '@/shared/assets/images/House.svg'
import BonusSvg from '@/shared/assets/images/BonusMenuIcon.svg'
import StoresSvg from '@/shared/assets/images/ChartBar.svg'
import UsersSvg from '@/shared/assets/images/UsersThree.svg'
import EmployeesSvg from '@/shared/assets/images/UserSwitch.svg'
import EmployementSvg from '@/shared/assets/images/FileLock.svg'
import SocialProgramSvg from '@/shared/assets/images/HandHeart.svg'
import FoundationSvg from '@/shared/assets/images/Heartbeat.svg'
import BagSvg from '@/shared/assets/images/BagSimple.svg'
import ListSvg from '@/shared/assets/images/ListBullets.svg'
import DollarSvg from '@/shared/assets/images/Money.svg'
import PercentSvg from '@/shared/assets/images/Percent.svg'
import CoinsSvg from '@/shared/assets/images/Coins.svg'
import PinSvg from '@/shared/assets/images/MapPinLine.svg'
import WalletSvg from '@/shared/assets/images/Wallet.svg'
import SettingsSvg from '@/shared/assets/images/GearSix.svg'
import InvitationsSvg from '@/shared/assets/images/MessengerLogo.svg'
import SocialApplicationsSvg from '@/shared/assets/images/UserCirclePlus.svg'
import GroupsSvg from '@/shared/assets/images/UserList.svg'
import NotificationsSvg from '@/shared/assets/images/PaperPlaneTilt.svg'
import MarketSvg from '@/shared/assets/images/Bank.svg'
import CabinetSvg from '@/shared/assets/images/BonusMenuIcon.svg'
import ChartSvg from '@/shared/assets/images/ChartUp.svg'
import InvoiceSvg from '@/shared/assets/images/Bank.svg'
import AirplaneSvg from '@/shared/assets/images/AirplaneTilt.svg'
import SearchSvg from '@/shared/assets/images/MagnifyingGlass.svg'
import TicketSvg from '@/shared/assets/images/Bag.svg'
import ClipboardText from '@/shared/assets/images/ClipboardText.svg'
import BankSvg from '@/shared/assets/images/Bank.svg'
import SecuritySvg from '@/shared/assets/images/SealCheck.svg'

export const SidebarMenu = () => {
    const community = useAppSelector(selectCommunityInfo)
    const type = useAppSelector(selectSidebarType)
    const location = useLocation()
    const loyaltyLevelsGate = useAppSelector(selectLoyaltyLevelsGate)
    const restaurantMenusGate = useAppSelector(selectRestaurantMenusGate)
    const isLoyaltyLevelsOpen = location.pathname.startsWith('/loyalty-levels/')
    const isRestaurantMenusOpen = location.pathname.startsWith('/restaurant-menus/')

    switch (type) {
        case SidebarType.bsp:
            return (
                <div className="flex flex-col gap-2 mt-[18px]" >
                    <SidebarItem icon={HouseSvg} title="Главная" href="/?s_type=default" />
                    {isDeploymentFeatureEnabled('programMarket') && (['partner', 'manufacturer', 'foundation'].includes(community.type)) &&
                        <SidebarSub icon={MarketSvg} title="Маркет программ">
                            <SidebarItem icon={CabinetSvg} title="Кабинет" href="/social-market?s_type=bsp" />
                            <SidebarItem icon={ListSvg} title="Транзакции" href="/social-market/transactions?s_type=bsp" />
                            <SidebarItem icon={BagSvg} title="Партнеры" href="/social-market/partners?s_type=bsp" />
                            <SidebarItem icon={FoundationSvg} title="Фонды" href="/social-market/foundations?s_type=bsp" />
                        </SidebarSub>
                    }
                    {community.type === "foundation" && (
                        <SidebarItem
                            icon={ClipboardText}
                            title="Инструкция НКО"
                            href="/doc/lk-nko.pdf"
                            external
                        />
                    )}
                </div>
            )
        default:
            return (
                <div className="flex flex-col gap-2 mt-[18px]" >
                    <SidebarItem icon={HouseSvg} title="Главная" href="/" />
                    <SidebarSub icon={BonusSvg} title="Бонусы">
                        <SidebarItem icon={WalletSvg} title="Кошелек" href="/bonuses/list" />
                        <SidebarItem icon={InvoiceSvg} title="Счета" href="/bonuses/invoices" />
                        <SidebarItem icon={DollarSvg} title="Транзакции" href="/bonuses/transactions" />
                        <SidebarItem icon={UsersSvg} title="Транзакции клиентов" href="/bonuses/processing-transactions" />
                        <SidebarItem icon={BonusSvg} title="Начисления" href="/bonuses/accruals" />
                        <SidebarItem icon={ClipboardText} title="Отчеты" href="/bonuses/reports" />
                    </SidebarSub>
                    {isDeploymentFeatureEnabled('marketingCampaigns') && (
                        <SidebarSub icon={ChartSvg} title="Маркетинговые кампании">
                            <SidebarItem icon={ListSvg} title="Список" href="/marketing-campaigns" />
                            <SidebarItem icon={ClipboardText} title="Отчеты" href="/marketing-campaigns/reports" />
                        </SidebarSub>
                    )}
                    {isDeploymentFeatureEnabled('promotions') && community.is_promotions_enabled && (
                        <SidebarItem icon={PercentSvg} title="Акции" href="/promotions" />
                    )}
                    {isDeploymentFeatureEnabled('loyaltyLevels') && loyaltyLevelsGate.status !== 'disabled' && (
                        <SidebarSub icon={CoinsSvg} title="Уровни лояльности" defaultOpen={isLoyaltyLevelsOpen}>
                            <SidebarItem icon={ChartSvg} title="Статистика" href="/loyalty-levels/statistics" />
                            <SidebarItem icon={CoinsSvg} title="Начисления кэшбэка" href="/loyalty-levels/accruals" />
                            <SidebarItem icon={ClipboardText} title="Отчёты" href="/loyalty-levels/reports" />
                            <SidebarItem icon={SettingsSvg} title="Настройка уровней лояльности" href="/loyalty-levels/settings" />
                        </SidebarSub>
                    )}
                    {isDeploymentFeatureEnabled('restaurantMenus') && restaurantMenusGate.status !== 'disabled' && (
                        <SidebarSub icon={TicketSvg} title="Меню ресторанов" defaultOpen={isRestaurantMenusOpen}>
                            <SidebarItem icon={ChartSvg} title="Статистика" href="/restaurant-menus/statistics" />
                            <SidebarItem icon={ListSvg} title="Заказы" href="/restaurant-menus/orders" />
                            <SidebarItem icon={SettingsSvg} title="Настройка меню ресторанов" href="/restaurant-menus/settings" />
                        </SidebarSub>
                    )}
                    {community.type === 'partner' &&
                        <SidebarSub icon={StoresSvg} title="Торговые точки">
                            <SidebarItem icon={ListSvg} title="Список" href="/partner/stores" />
                            <SidebarItem icon={DollarSvg} title="Транзакции" href="/partner/transactions" />
                            <SidebarItem icon={PercentSvg} title="Скидки" href="/partner/discounts" />
                            <SidebarItem icon={PinSvg} title="Карта" href="/partner/map" />
                        </SidebarSub>
                    }
                    <SidebarSub icon={UsersSvg} title="Пользователи">
                        <SidebarItem icon={ListSvg} title="Список" href="/users/list" />
                        <SidebarItem icon={UsersSvg} title="Привлечение пользователей по ссылке" href="/users/attracted" />
                        <SidebarItem icon={GroupsSvg} title="Группы" href="/users/groups" />
                        <SidebarItem icon={InvitationsSvg} title="Приглашения" href="/users/invitations" />
                        {community.is_user_creation_enabled && (
                            <SidebarItem icon={SocialApplicationsSvg} title="Создание пользователей" href="/users/creation" />
                        )}
                        <SidebarItem icon={SocialApplicationsSvg} title="Конструктор профиля" href="/users/profilebuilder" />
                    </SidebarSub>
                    <SidebarSub icon={EmployeesSvg} title="Сотрудники">
                        <SidebarItem icon={ListSvg} title="Список" href="/employees/list" />
                        <SidebarItem icon={GroupsSvg} title="Группы" href="/employees/groups" />
                        <SidebarItem icon={InvitationsSvg} title="Приглашения" href="/employees/invitations" />
                        <SidebarItem icon={SocialApplicationsSvg} title="Конструктор профиля" href="/employees/profilebuilder" />
                    </SidebarSub>
                    {isDeploymentFeatureEnabled('aviabooking') && (
                        <SidebarSub icon={AirplaneSvg} title="Авиабилеты">
                            <SidebarItem icon={SearchSvg} title="Поиск билетов" href="/avia-booking" />
                            <SidebarItem icon={TicketSvg} title="Список билетов" href="/avia-booking/bookings" />
                        </SidebarSub>
                    )}
                    <SidebarItem icon={EmployementSvg} title="Трудоустройство" href="/employment" />
                    <SidebarItem icon={SocialProgramSvg} title="Социальные программы" href="/social-programs" />
                    {isDeploymentFeatureEnabled('programMarket') && (['partner', 'manufacturer', 'foundation'].includes(community.type)) &&
                        <SidebarItem icon={MarketSvg} title="Маркет программ" href="/social-market?s_type=bsp" />
                    }
                    <SidebarItem icon={FoundationSvg} title="Фонды" href="/foundations" />
                    <SidebarItem icon={BankSvg} title="Бизнес-карты" href="/business-cards" />
                    <SidebarItem icon={NotificationsSvg} title="Рассылки" href="/notifications" />
                    <SidebarSub icon={SecuritySvg} title="Безопасность">
                        <SidebarItem icon={ListSvg} title="Белый список" href="/security/whitelist" />
                        <SidebarItem icon={ListSvg} title="ACL" href="/security/acl" />
                        <SidebarItem icon={ListSvg} title="Действия администраторов" href="/security/admin-actions" />
                        <SidebarItem icon={ListSvg} title="Вызовы партнёрского API" href="/security/partner-api-calls" />
                        <SidebarItem icon={ClipboardText} title="Документация партнёрского API" href="/security/partner-api-docs" />
                    </SidebarSub>
                    <SidebarItem icon={SettingsSvg} title="Настройки" href="/settings" />
                    {community.type === "foundation" && (
                        <SidebarItem
                            icon={ClipboardText}
                            title="Инструкция НКО"
                            href="/doc/lk-nko.pdf"
                            external
                        />
                    )}
                </div>
            )
    }
}
